import React from 'react';
import PropTypes from 'prop-types';
import { DotsWrapper, Dot } from './styles';

export const CarouselPillDots = ({ count, activeIndex, onDotClick }) => (
  <DotsWrapper>
    {Array.from({ length: count }, (_, i) => (
      <Dot
        key={i}
        $active={i === activeIndex}
        disabled={i === activeIndex}
        onClick={() => onDotClick(i)}
        aria-label={`Slide ${i + 1}`}
        aria-current={i === activeIndex}
      />
    ))}
  </DotsWrapper>
);

CarouselPillDots.displayName = 'CarouselPillDots';

CarouselPillDots.propTypes = {
  count: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  onDotClick: PropTypes.func.isRequired,
};
